import { render, staticRenderFns } from "./withdrawnRemittances.vue?vue&type=template&id=d3a744b0&"
import script from "./withdrawnRemittances.vue?vue&type=script&lang=js&"
export * from "./withdrawnRemittances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports